/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState, useContext, useRef} from 'react';
import CampaignContext from '../context/CampaignContext';
import UserContext from '../context/UserContext';
import '../styles/diceHisto.css';
import i18next from 'i18next';
import { EyeOffIcon, ChevronDoubleRightIcon } from '@heroicons/react/outline'
import {isDesktop, isMobile} from "react-device-detect";
import {getLabelDice} from '../utils/dice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDiceD20, faSyncAlt, faHandPointRight, faSkull, faChild} from '@fortawesome/free-solid-svg-icons'

const cleanDuplicate = (arrayRoll, userUid, campaignUserUidDm, diceLoaded = 10) => {

  let savedDate = null;
  let savedDateFix = null;
  let savedPictureUrl = null;

  // Fix the undefined on roll date
  for(let i = 0; i < arrayRoll.length; i+=1) {
    if(!arrayRoll[i].createdAt){
      arrayRoll[i].createdAt = savedDateFix;
    }
    savedDateFix = arrayRoll[i].createdAt;
  }
  let arrayVisible = [];
  for (let i = 0; i < arrayRoll.length; i+= 1) {
    const isHidedUpdate = arrayRoll[i].isHided && arrayRoll[i].diceType === 'update';
    if(!arrayRoll[i].isHided || (!isHidedUpdate && arrayRoll[i].userUid === userUid) || campaignUserUidDm === userUid) {
      arrayVisible.push(arrayRoll[i]);
    }
  }
  arrayVisible.splice(0, arrayVisible.length - diceLoaded);
  arrayVisible.map((roll,i) => {
    roll.displayPicture = true;
    if(roll.createdAt && savedDate !== roll.createdAt) {
      savedDate = roll.createdAt;
      roll.showDate = true;
    } else {
      roll.showDate = false;
    }
    if(roll.pictureUserSendRoll && savedPictureUrl !== roll.pictureUserSendRoll) {
      savedPictureUrl = roll.pictureUserSendRoll;
    } else if(i >= 1){
      arrayVisible[i-1].displayPicture = false;
    }
    return null;
  });
  return arrayVisible;
};

const DiceHistorical = (props) => {
  const {list} = props;
  const {user} = useContext(UserContext);
  const {campaign} = useContext(CampaignContext);
  const [limitHisto, setLimitHisto] = useState(15);
  const [diceHistorical, setDiceHistorical] = useState([]);
  const [view,setView] = useState('dice');
  const histoView = useRef(null)

  useEffect(() => {
    if(document.getElementById("last") && isMobile) {
      setTimeout(function(){
        document.getElementById("last").scrollIntoView({ behavior: 'smooth'});
      }, 250);
    }
  });

  useEffect(() => {
    const indexed = list.map((roll, i) => ({ ...roll, _originalIdx: i }));
    const filtered = indexed.filter(roll => view === 'dice' ? roll.diceType !== 'update' : (roll.diceType === 'update' && (roll.userUid === user.uid || campaign.idUserDm === user.uid)));
    const rolls = cleanDuplicate(filtered, user.uid, campaign.idUserDm, limitHisto);
    setDiceHistorical(rolls.reverse());
  }, [list, limitHisto, view]);

  useEffect(() => {
    const el = document.getElementById('animationHisto');
    if (!el) return;
    el.classList.remove('critAnim');
    const t = setTimeout(() => {
      const el2 = document.getElementById('animationHisto');
      if (el2) el2.classList.add('critAnim');
    }, 100);
    return () => clearTimeout(t);
  }, [list]);

  return (
    <div ref={histoView} className='histoView' style={{maxHeight: isDesktop ? `${window.innerHeight - 90}px` : 'none'}}>
      <div className='histoTabs'>
        <button
          className={`histoTab${view === 'dice' ? ' active' : ''}`}
          onClick={() => setView('dice')}
        >
          <FontAwesomeIcon icon={faDiceD20} className="histoTabIcon" />
          <span className="histoTabText">{i18next.t('dice')}</span>
        </button>
        <button
          className={`histoTab${view === 'update' ? ' active' : ''}`}
          onClick={() => setView('update')}
        >
          <FontAwesomeIcon icon={faSyncAlt} className="histoTabIcon" />
          <span className="histoTabText">{i18next.t('update')}</span>
        </button>
      </div>
      <div className='histoActions'>
        {props.collapsible && (
          <button
            className="collapseChatToggle"
            onClick={() => props.setHideChat(true)}
            title={i18next.t('hideChat')}
          >
            <ChevronDoubleRightIcon className="hideRollIcon" />
          </button>
        )}
        <button
          className={`hideRollToggle${props.hideRollSwitch ? ' on' : ''}`}
          onClick={() => props.setHideRoll(!props.hideRollSwitch)}
        >
          <EyeOffIcon className="hideRollIcon" />
          <span>{i18next.t('hide roll')}</span>
        </button>
        <button className="empty" onClick={() => setLimitHisto(limitHisto + 10)}>
          {i18next.t('load more')}
        </button>
      </div>
      <ul className="listHisto">
        {diceHistorical.length > 0 && (
          diceHistorical.map((histo, i) => {
            if(view === 'dice' && user && campaign) {
              return (
                <ChatBubbleDice
                  histo={histo}
                  user={user}
                  key={i}
                  i={i}
                  campaign={campaign}
                  firstOfGroup={!diceHistorical[i+1] || histo.userUid !== diceHistorical[i+1].userUid}
                  lastOfGroup={!diceHistorical[i-1] || histo.userUid !== diceHistorical[i-1].userUid}
                  onReact={props.onReact}
                />
              )
            }
            if(view === 'update' && user && campaign) {
              return (
                <ChatBubbleUpdate
                  histo={histo}
                  user={user}
                  key={i}
                  i={i}
                  campaign={campaign}
                />
              )
            }
            return null;
          })
        )}
        {diceHistorical.length === 0 && (
          <p className='noDiceMessage'>
            {i18next.t('no roll')}
          </p>
        )}
      </ul>
    </div>
  );
}

const REACTION_EMOJIS = ['🎉', '💀', '😬'];

const ChatBubbleDice = (props) => {
  const {user, histo, i, campaign, firstOfGroup, lastOfGroup, onReact} = props;

  const isMyRoll = (roll) => {
    if(user.uid === roll.userUid) {
      return true;
    } else if (campaign.idUserDm === user.uid && roll.isDmRoll) {
      return true;
    }
    return false;
  }

  return (
    <div>
      {histo.showDate && (
        <span className='date'>
          {histo.createdAt}
        </span>
      )}
      <div className={`${isMyRoll(histo) ? "containerRowReverse" : "containerRow"}`}>
        {histo.displayPicture && !isMyRoll(histo) && (
          <div
            className={'userPictureRoll'}
            style={{backgroundImage: `url(${histo.pictureUserSendRoll})`}}
          />
        )}
        <div className={`bubbleWrapper${isMyRoll(histo) ? ' bubbleWrapperRight' : ''}`}>
          <li
            id={i === 0 ? 'last' : null}
            className={`${isMyRoll(histo) ? "myhistoRow" : "histoRow"} bubbleHisto ${lastOfGroup && firstOfGroup ? 'aloneOnGroup' : ''} ${lastOfGroup ? 'lastOfGroup' : ''} ${firstOfGroup ? 'firstOfGroup' : ''}`}
          >
            <div className='histoLeftSide'>
              <span>{histo.userName}</span>
              <span>{getLabelDice(histo,campaign, user)}</span>
              {histo.isHided && <EyeOffIcon className="iconHide"/>}
            </div>
            <div className='histoRightSide'>
              {i === 0 && histo.diceType === 100 && histo.stat && histo.value > histo.stat.value && histo.value >= (histo.critFail ?? 90) && (
                <FontAwesomeIcon id='animationHisto' className={'histoFailCritIcon critAnim'} icon={faSkull}/>
              )}
              {i === 0 && histo.diceType === 100 && histo.stat && histo.value <= histo.stat.value && histo.value <= (histo.critSuccess ?? 10) && (
                <FontAwesomeIcon id='animationHisto' className={'histoSuccesCritIcon critAnim'} icon={faChild}/>
              )}
              <span>{histo.value}</span>
              {histo.rolls && (
                <span style={{ fontSize: '0.75rem', opacity: 0.7, display: 'block', textAlign: 'right', maxWidth: '80px', overflowWrap: 'break-word' }}>
                  {histo.rolls.join(' + ')}
                </span>
              )}
            </div>
          </li>
          {onReact && (i === 0 || REACTION_EMOJIS.some(e => (histo.reactions?.[e] || []).length > 0)) && (
            <div className={`reactionCorner${isMyRoll(histo) ? ' reactionCornerRight' : ' reactionCornerLeft'}`}>
              {REACTION_EMOJIS.map(emoji => {
                const uids = histo.reactions?.[emoji] || [];
                const active = uids.includes(user.uid);
                if (i !== 0 && uids.length === 0) return null;
                return (
                  <button
                    key={emoji}
                    className={`reactionBtn${active ? ' active' : ''}${uids.length === 0 ? ' empty' : ''}`}
                    onClick={i === 0 ? () => onReact(histo._originalIdx, emoji) : undefined}
                    style={i !== 0 ? { cursor: 'default', pointerEvents: 'none' } : undefined}
                    title={uids.length > 0 ? `${uids.length} réaction(s)` : ''}
                  >
                    {emoji}{uids.length > 0 && <span className="reactionCount">{uids.length}</span>}
                  </button>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

const ChatBubbleUpdate = (props) => {
  const {user, histo, i, campaign} = props;
  const isMyRoll = (roll) => {
    if(user.uid === roll.userUid) {
      return true;
    } else if (campaign.idUserDm === user.uid && roll.isDmRoll) {
      return true;
    }
    return false;
  }

  return (
    <div>
      {histo.showDate && (
        <span className='date'>
          {histo.createdAt}
        </span>
      )}
      <div className={`${isMyRoll(histo) ? "containerRowReverse" : "containerRow"}`}>
        {histo.displayPicture && !isMyRoll(histo) && (
          <div
            className={'userPictureRoll'}
            style={{backgroundImage: `url(${histo.pictureUserSendRoll})`}}  
          />
        )}
        <li
          id={i === 0 ? 'last' : null}
          className={`${isMyRoll(histo) ? "myhistoRow" : "histoRow"} bubbleHistoUpdate`}
          style={!isMyRoll(histo) ? {margin: '0.5rem 2.25rem'} : null}
        >
          <div className='histoLeftSide'>
            {histo.stat && (
              <div className='updateBlock'>
                <span>
                  {`${i18next.t(histo.stat.label)} ${histo.stat.value}`}
                </span>
                  <FontAwesomeIcon className='iconUpdate' icon={faHandPointRight}/>
                <span>
                  {histo.value}
                </span>
              </div>
            )}
            <span>
              {histo.userName}
            </span>
            {histo.isHided && (
              <EyeOffIcon className="iconHide"/>
            )}
          </div>
        </li>
      </div>
    </div>
  );
}

export default DiceHistorical